import { sendLeadFormHeapEvents } from 'client/javascript/form_analytics';
import { showElements, hideElements } from 'client/javascript/util/dom_utils';
import { setupPhoneInput } from 'client/javascript/phone';
import Form from 'client/javascript/lead_form';
import { submitLead } from 'client/javascript/submit_lead';
import { ENTERPRISE_VALUE, CUSTOM_BUILDOUT_VALUE, OFFICE_SUITE_VALUE } from 'shared/util/search_constants';

const LEAD_SOURCE_DETAIL = 'Jumbotron Short Form';
const OFFICE_SUITE_JUMBOTRON_SELECTOR = '#office-suite-jumbotron';
const CUSTOM_BUILDOUT_JUMBOTRON_SELECTOR = '#custom-buildout-jumbotron';
const ENTERPRISE_JUMBOTRON_SELECTOR = '#enterprise-jumbotron';

async function onSubmit(event, values) {
  const form = event.target;
  const successMessage = form.closest('.jumbotron').querySelector('.jumbotron__form-success');
  const leadSourceSubtype = 'Consultation - Market Interest';
  const companySize = document.querySelector('#search-chip__capacity span').textContent.trim();
  const valuesWithCompanySize = {
    ...values,
    company_size: companySize
  };

  await submitLead(
    {
      ...valuesWithCompanySize,
      submission_type: 'lead',
      lead_source_subtype: leadSourceSubtype
    },
    LEAD_SOURCE_DETAIL
  );
  sendLeadFormHeapEvents(valuesWithCompanySize, LEAD_SOURCE_DETAIL);
  hideElements(form);
  showElements(successMessage);
}

export function setupJumbotronForms() {
  const forms = document.querySelectorAll('.jumbotron form');

  Array.from(forms).forEach(form => {
    const phoneInput = form.querySelector('#phone');
    setupPhoneInput(phoneInput);
    new Form(form, onSubmit); // eslint-disable-line no-new
  });
}

export function updateJumbotrons(capacity) {
  if (capacity === OFFICE_SUITE_VALUE) {
    showElements(OFFICE_SUITE_JUMBOTRON_SELECTOR);
    hideElements(CUSTOM_BUILDOUT_JUMBOTRON_SELECTOR, ENTERPRISE_JUMBOTRON_SELECTOR);
  } else if (capacity === CUSTOM_BUILDOUT_VALUE) {
    showElements(CUSTOM_BUILDOUT_JUMBOTRON_SELECTOR);
    hideElements(ENTERPRISE_JUMBOTRON_SELECTOR, OFFICE_SUITE_JUMBOTRON_SELECTOR);
  } else if (capacity === ENTERPRISE_VALUE) {
    hideElements(OFFICE_SUITE_JUMBOTRON_SELECTOR, CUSTOM_BUILDOUT_JUMBOTRON_SELECTOR);
    showElements(ENTERPRISE_JUMBOTRON_SELECTOR);
  } else {
    hideElements(OFFICE_SUITE_JUMBOTRON_SELECTOR, CUSTOM_BUILDOUT_JUMBOTRON_SELECTOR, ENTERPRISE_JUMBOTRON_SELECTOR);
  }
}

export function areJumbotronsVisible() {
  const jumbotrons = document.querySelectorAll('.jumbotron');
  const isVisible = Array.from(jumbotrons).some(jumbotron => {
    return jumbotron.offsetParent !== null;
  });
  return isVisible;
}
